window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

//post shortcut
window.post = function(url, data, content_type = 'application/json') {
    return fetch(url, {method: "POST", headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': content_type
        }, body: JSON.stringify(data)});
}

window.$ = window.jQuery = require('jquery');

window.Popper = require('popper.js/dist/umd/popper.js').default;
require('jquery-ui');
require('bootstrap');
require('./custom/initTogglers');
//require('./custom/promocodeCountdown');
require('./custom/fieldValidation');
require('./custom/termsController');
